module.exports = __webpack_public_path__ + "img/bg-vip1.51973908.png";